import { render, staticRenderFns } from "./ResizeObserver.vue?vue&type=template&id=67b77780&scoped=true&"
import script from "./ResizeObserver.vue?vue&type=script&lang=ts&"
export * from "./ResizeObserver.vue?vue&type=script&lang=ts&"
import style0 from "./ResizeObserver.vue?vue&type=style&index=0&id=67b77780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b77780",
  null
  
)

export default component.exports